// WATER RIGHTS STATUS
export const GET_WATER_RIGHTS_STATUSES = '/water_rights_status/query';
export const GET_WATER_RIGHTS_STATUS = '/water_rights_status/';
export const POST_WATER_RIGHTS_STATUS = '/water_rights_status/';
export const PUT_WATER_RIGHTS_STATUS = '/water_rights_status/';
export const DELETE_WATER_RIGHTS_STATUS = '/water_rights_status/';
export const CHECK_WATER_RIGHTS_STATUS_EXISTS = '/water_rights_status/query';
